import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const InvoiceTable = ({ invoiceRecord }) => {
  const headers = [
    "BILLING_DOC_NO",
    "BILLING_DOC_TYPE",
    "BILLING_DATE",
    "DIVISION_CODE",
    "CUST_CODE",
    "ITEM_CODE",
    "SALE_QTY",
    "BONUS_QTY",
    "SALABLE_RETURN_QTY",
    "BREAKAGE_RETURN_QTY",
    "EXP_RETURN_QTY",
    "WERKS",
    "BATCH_NO",
    "KNUMV",
    "IT_PARTNER",
    "CURR_DATE",
  ];

  return (
    <TableContainer component={Paper} sx={{ maxHeight: "60%" }}>
      <Table stickyHeader>
        {/* Table Header */}
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
                key={index}
                sx={{
                  color: "#f5f5f5",
                  backgroundColor: "#000000",
                  fontSize: "0.75em",
                  padding: "0.4em",
                  textAlign: "center",
                  fontFamily: "Montserrat",
                }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {/* Table Body */}
        <TableBody>
          {invoiceRecord.length > 0 ? (
            invoiceRecord.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((header, colIndex) => (
                  <TableCell key={colIndex}>{row[header] ?? "-"}</TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={headers.length} align="center">
                No Data Available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceTable;
